import React from 'react';
import ContactSection from '../components/ContactSection/ContactSection';

const ContactPage = () => {
  return (
    <>
      
      <ContactSection />
    </>
  );
};

export default ContactPage;
